// extracted by mini-css-extract-plugin
module.exports = {"main":"_app_main__tUF0-"};